import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const allItemsInBinReducer = (state = [], action) => {
  const actionName = serverApis.getAllItemsInBin.actionName;

  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return { binCode: action.referenceObject, items: action.json.rows };

    case getResetAction(actionName):
      return [];
    default:
      return state;
  }
};
